import React from "react";
import {Box, Icon} from "@material-ui/core";
import {NavLink} from "react-router-dom";
import AppBreadCrumb from "../../../../components/AppBreadCrumb/AppBreadCrumb";

/**
 * BreadcrumbNav component to render navigation breadcrumbs
 */
const BreadcrumbNav = ({breadcrumbData, classes, location}) => {
  return (
    <AppBreadCrumb>
      {breadcrumbData.map((crumb, index) => (
        <Box
          key={index}
          component={NavLink}
          exact
          to={{
            pathname: crumb.path,
            state: {
              orgIdHistory: location.state && location.state.orgIdHistory,
              orgNameHistory: location.state && location.state.orgNameHistory,
              deptIdHistory: location.state && location.state.deptIdHistory,
              deptNameHistory: location.state && location.state.deptNameHistory,
            },
          }}
          className={classes.breadcrumbItem}
          activeClassName={classes.activeBreadcrumbItem}
        >
          {crumb.icon && (
            <Icon className={classes.breadcrumpIcon}>{crumb.icon}</Icon>
          )}
          <Box className={classes.breadcrumpLabel}>{crumb.name}</Box>
        </Box>
      ))}
    </AppBreadCrumb>
  );
};

/**
 * Helper functions to get breadcrumb data for different page types
 */

/**
 * Get breadcrumb data for organization department patient profile page
 */
export const getOrgDeptPatientBreadcrumbData = (location, patient, params) => [
  {
    icon: "business",
    name: "Clinics",
    path: "/orgs",
  },
  {
    name: `${
      location.state && location.state ? `${location.state.orgNameHistory}` : ""
    }`,
    path: `/orgs/${location.state && location.state.orgIdHistory}`,
  },
  {
    name: `${
      location.state && location.state
        ? `${location.state.deptNameHistory}`
        : ""
    }`,
    path: `/orgs/departments/${location.state && location.state.deptIdHistory}`,
  },
  {
    name: `${patient ? `${patient.firstName} ${patient.lastName}` : ""}`,
    path: `/orgs/departments/patients/${params.id}`,
  },
];

/**
 * Get breadcrumb data for admin department patient profile page
 */
export const getAdminDeptPatientBreadcrumbData = (
  location,
  patient,
  params
) => [
  {
    icon: "apartment",
    name: "Departments",
    path: "/departments",
  },
  {
    name: `${
      location.state && location.state
        ? `${location.state.deptNameHistory}`
        : ""
    }`,
    path: `/departments/${location.state && location.state.deptIdHistory}`,
  },
  {
    name: `${patient ? `${patient.firstName} ${patient.lastName}` : ""}`,
    path: `/departments/patients/${params.id}`,
  },
];

/**
 * Get appropriate breadcrumb data based on URL path
 */
export const getBreadcrumbData = (urlPath, location, patient, params) => {
  switch (urlPath) {
    case "/orgs/departments/patients/": {
      return getOrgDeptPatientBreadcrumbData(location, patient, params);
    }
    case "/departments/patients/": {
      return getAdminDeptPatientBreadcrumbData(location, patient, params);
    }
    default: {
      return [];
    }
  }
};

export default BreadcrumbNav;
